import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';
import { CreateUpdateHealthcareFacilityDto } from '../../../common/spdCore/autogenerated/spdApiClient';

interface HealthcareFacilityRegisterDataTabProps {
  healthcareFacility: CreateUpdateHealthcareFacilityDto;
  propertyChange: (obj: Partial<CreateUpdateHealthcareFacilityDto>) => void;
}

export const HealthcareFacilityRegisterDataTab: React.FC<
  HealthcareFacilityRegisterDataTabProps
> = props => {
  const [healthcareFacility, setHealthcareFacility] = useState(
    props.healthcareFacility,
  );

  useEffect(() => {
    setHealthcareFacility(props.healthcareFacility);
  }, [props.healthcareFacility]);

  const propertyChange = (obj: Partial<CreateUpdateHealthcareFacilityDto>) => {
    setHealthcareFacility({ ...healthcareFacility, ...obj });
    props.propertyChange(obj);
  };

  return (
    <div className="d-grid gap-3">
      <h5>Placówka lekarska</h5>
      <FormRow controlId="nameDoctor" label="Nazwa placówki">
        <Form.Control
          as="textarea"
          rows={3}
          value={healthcareFacility?.nameDoctor || ''}
          onChange={e => propertyChange({ nameDoctor: e.target.value })}
        />
      </FormRow>
      <FormRow controlId="nip" label="NIP">
        <Form.Control
          type="text"
          value={healthcareFacility?.nip || ''}
          onChange={e => propertyChange({ nip: e.target.value })}
        />
      </FormRow>
      <FormRow controlId="regon" label="REGON">
        <Form.Control
          type="text"
          value={healthcareFacility?.regon || ''}
          onChange={e => propertyChange({ regon: e.target.value })}
        />
      </FormRow>
      <FormRow controlId="entryContentDoctor" label="Wpis">
        <Form.Control
          as="textarea"
          rows={3}
          value={healthcareFacility?.entryContentDoctor || ''}
          onChange={e =>
            propertyChange({
              entryContentDoctor: e.target.value,
            })
          }
        />
      </FormRow>
      <FormRow
        controlId="p1WorkplaceOidExt"
        label="Kod resortowy (część V systemu SRKI)"
      >
        <Form.Control
          type="text"
          value={healthcareFacility?.p1WorkplaceOidExt || ''}
          onChange={e => propertyChange({ p1WorkplaceOidExt: e.target.value })}
        />
      </FormRow>

      <h5>Placówka psychologiczna</h5>
      <FormRow controlId="namePsychological" label="Nazwa placówki">
        <Form.Control
          as="textarea"
          rows={3}
          value={healthcareFacility?.namePsychological || ''}
          onChange={e =>
            propertyChange({
              namePsychological: e.target.value,
            })
          }
        />
      </FormRow>
      <FormRow controlId="nipPsychological" label="NIP">
        <Form.Control
          type="text"
          value={healthcareFacility?.nipPsychological || ''}
          onChange={e => propertyChange({ nipPsychological: e.target.value })}
        />
      </FormRow>
      <FormRow controlId="regonPsychological" label="REGON">
        <Form.Control
          type="text"
          value={healthcareFacility?.regonPsychological || ''}
          onChange={e =>
            propertyChange({
              regonPsychological: e.target.value,
            })
          }
        />
      </FormRow>
      <FormRow controlId="entryContentPsychological" label="Wpis">
        <Form.Control
          as="textarea"
          rows={3}
          value={healthcareFacility?.entryContentPsychological || ''}
          onChange={e =>
            propertyChange({
              entryContentPsychological: e.target.value,
            })
          }
        />
      </FormRow>
    </div>
  );
};
